import type { Resource } from '../../';
export const forms_field_lastName: Resource = {"default":"Last Name"};
